<template slot-scope="scope">
  <!-- 处理结果弹窗 -->
      <dialogModel
        :title="PopUpTitle"
        :visible="dialogUntie"
        @handleClose="handleCancelUntie"
        @handleOk="handleVerifyUntie"
      >
        <div class="dialog-content">
            <div class="content-left">
              <!-- 都显示 选择验证方式 -->
              <div class="verify-mode"><span style="color: red">*</span>验证方式：</div>
              <!-- 都显示 验证码输入 -->
              <div><span style="color: red">*</span>验证码：</div>
              <!-- 都显示 验证码输入 -->
              <div v-if="untieOrOther != ''">
                <span style="color: red">*</span>扫码绑定：
              </div>
            </div>
            <div class="content-right">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <!-- 都显示  选择验证方式 -->
                <div class="verify-mode verify-content">
                  <div
                    class="SelectVerify"
                    v-for="(item, index) in SelectVerify"
                    :key="index"
                  >
                    <div
                      :class="
                        item.id == SelectVerifyId
                          ? 'SelectIcon'
                          : 'NotSelectIcon'
                      "
                      @click="handelSelectVerify(item)"
                    ></div>
                    <div>{{ item.name }}</div>
                    <div>{{ item.data }}</div>
                  </div>
                </div>
                <!-- 都显示 获取验证码 -->
                <div class="verify-content">
                  <el-form-item prop="Code">
                    <div class="code-field">
                      <el-input
                        v-model="ruleForm.Code"
                        placeholder="请输入"
                        class="code-input"
                      ></el-input>
                      <span
                        class="verify"
                        @click="second == 60 ? handelInvoke() : ''"
                      >{{
                        second === totalSecond && sendNum == 0
                          ? "获取验证码"
                          : second === totalSecond && sendNum != 0
                          ? "再次获取验证码"
                          : second + `秒后重新发送`
                      }}</span>
                    </div>
                  </el-form-item>
                </div>
                <div class="Twe-Code" v-if="untieOrOther != ''">
                  <div></div>
                  <div>账户名：<span style="color: #666666">xxx用户2511</span></div>
                </div>
              </el-form>
            </div>
          </div>
      </dialogModel>
</template>

<script>
// 引入JSEncrypt用于RSA加密
import JSEncrypt from "jsencrypt";
// 引入接口
import {
  postSendAuthCode, // 获取邮箱/手机验证码
} from "../../../../../assets/api/index";
// 封装的表单验证
import { vxRule } from "../../../../../../untils/FormValidation/validate-form";
import { set } from "vue";
// 在弹窗中获取验证码 destroyed中的应写在handleClose/handleUnderstand中才生效
export default {
  props: {
    dialogUntie: {},
    PopUpTitle: {},
    untieOrOther: {}, // 空解绑  1绑定 2更换
  },
  components: {},
  data() {
    return {
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
      ruleForm: {
        Code: "", // 验证码
      },
      rules: {
        // 参数3 change触发，为空时使用自定义提示语    blur
        // 参数4 自定义提示语 / 没有时用封装的
        // 参数2 封装的规则名 / 自定义规则
        // 参数1 false时不验证为空
        Code: vxRule(true, "", "blur", "请输入验证码"),
      }, // 表单验证
      SelectVerify: [
        { name: "手机验证", data: "", id: "0" },
        { name: "邮箱验证", data: "", id: "1" },
      ], // 可选的验证方法
      SelectVerifyId: "0", //选中的验证方法
    };
  },
  watch: {
    // 监听
    dialogUntie: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            Code: "", // 验证码
          };
          // 关闭验证码倒计时 数据归位
          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.sendNum = "0";
          this.SelectVerifyId = "0"; //选中的验证方法
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    // 给SelectVerify列表赋值 手机号 邮箱
    this.SelectVerify[0].data = this.$store.getters.getUser.phone;
    this.SelectVerify[1].data = this.$store.getters.getUser.mail;
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  methods: {
    //切换验证方式
    handelSelectVerify(item) {
      this.SelectVerifyId = item.id;
    },
    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke() {
      console.log(2);
      // // 获取验证码接口
      // var data = {};
      // data.data = {
      //   mail: this.$store.getters.getUser.mail,
      //   mobile: this.$store.getters.getUser.phone,
      //   type: this.SelectVerifyId,
      // };
      // postSendAuthCode(data).then((res) => {
      //   if (res.code == 0) {
      //     this.Countdown();
      //     this.$tool.PromptBox("success", "验证码已发送");
      //   } else {
      //     // 验证码发送失败
      //     this.$tool.PromptBox("error", "验证码发送失败");
      //   }
      // });
    },
    // 发送验证码
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },

    // 取消 关闭弹窗
    handleCancelUntie() {
      this.$emit("handleCancelUntie");
    },

    // 确认
    handleVerifyUntie() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleVerifyUntie");
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  line-height: 35px !important;
  border: 1px solid #409eff ;
}
/deep/.el-input {
  height: 35px;
  line-height: 35px;
  font-size: 14px;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.dialog-content {
    width: 420px;
    min-height: 50px;
    margin: 0 auto;
    display: flex;
    .content-left {
      min-width: 80px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333333;
      text-align: right;
      font-weight: 400;
      .verify-mode {
        height: 70px;
        line-height: 35px;
      }
      div {
        height: 35px;
        line-height: 35px;
        margin-bottom: 30px;
      }
    }
    .content-right {
      width: 350px;
      .verify-content:nth-child(1) {
        margin-top: 0px;
      }
      .verify-content {
        height: 35px;
        line-height: 35px;
        margin-top: 30px;
        position: relative;

        // 选择验证方法
        .SelectVerify {
          width: 100%;
          height: 35px;
          line-height: 35px;
          display: flex;
          div {
            margin-right: 20px;
            margin-left: 10px;
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          .NotSelectIcon {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background-image: url("../../../../../assets/imgs/weigouxuan@3x.svg");
            background-size: 100% 100%;
            margin: auto 0;
          }
          .SelectIcon {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
            background-size: 100% 100%;
            margin: auto 0;
          }
        }
      }
      .code-field {
        position: relative;
        width: 100%;
        height: 35px;
        line-height: 35px;
      }
      .verify {
        position: absolute;
        right: 12px;
        top: 0;
        bottom: 0;
        height: 35px;
        line-height: 35px;
        display: inline-flex;
        align-items: center;
        color: #409eff;
        cursor: pointer;
        font-size: 14px;
        z-index: 2;
        user-select: none;
        white-space: nowrap;
      }
      .code-input {
        width: 100%;
        height: 35px !important;
        line-height: 35px !important;
        /deep/ .el-input__inner {
          height: 35px !important;
          line-height: 35px !important;
          padding-right: 110px;
        }
      }
      .verify-mode {
        height: 70px;
      }
      .Twe-Code {
        width: 80%;
        height: 160px;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        div {
          width: 120px;
          height: 120px;
          background-image: url("../../../../../assets/imgs/erweima2.svg");
          background-size: 100% 100%;
          margin: 0 auto;
        }
        div {
          width: 100%;
          text-align: center;
          margin-top: 15px;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
        }
      }
    }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
